import React from 'react';
import PropTypes from 'prop-types';
import Input from 'Validation/Input';

class ModalInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      value: this.props.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  handleChange(event) {
    this.setState({
      value: event.target.value,
    });

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  render() {
    let autoComplete = 'off';
    if (this.props.autoComplete) {
      autoComplete = 'on';
    }

    let className = 'modal-input-container control-group';
    if (this.props.type === 'hidden') {
      className += ' hidden';
    }

    return (
      <div className={className}>
        <label className="control-label" htmlFor={this.props.htmlFor}>{this.props.label}</label>
        <div className="controls">
          <Input
            type={this.props.type}
            autoComplete={autoComplete}
            className="modal-input input-xlarge"
            id={this.props.id}
            name={this.props.name}
            value={this.state.value}
            onChange={this.handleChange}
            validations={this.props.validations}
          />
        </div>
      </div>
    );
  }
}

ModalInput.defaultProps = {
  autoComplete: true,
  value: '',
  onChange: null,
  validations: [() => {}],
};

ModalInput.propTypes = {
  id: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string,
  autoComplete: PropTypes.bool,
  onChange: PropTypes.func,
  validations: PropTypes.arrayOf(PropTypes.func),
};

export default ModalInput;




// WEBPACK FOOTER //
// ./src-react/Modals/components/ModalForm/ModalInput/index.jsx